export default __webpack_public_path__ + "static/media/Laptop.17e93257.png";